const cleanData = (values) => {
  let filterArray = ["_", "__typename"];
  let data = values;
  filterArray.map((x) => {
    delete data[x];
    return data;
  });
  // console.log("DATA HERE----------------------------", data, values);

  if (
    Array.isArray(values["supervisionLevelPeer"]) &&
    values["supervisionLevelPeer"][0] === "YES"
  ) {
    data["supervisionLevelPeer"] = "YES";
  } else if (
    Array.isArray(values["supervisionLevelPeer"]) &&
    values["supervisionLevelPeer"].length === 0
  ) {
    delete data["supervisionLevelPeer"];
  }

  if (
    Array.isArray(values["supervisionLevelSub"]) &&
    values["supervisionLevelSub"][0] === "YES"
  ) {
    data["supervisionLevelSub"] = "YES";
  } else if (
    Array.isArray(values["supervisionLevelSub"]) &&
    values["supervisionLevelSub"].length === 0
  ) {
    delete data["supervisionLevelSub"];
  }

  if (values["empExperienceRequired"] === "NO") {
    data["empExperienceMonths"] = "0";
  }

  return data;
};

const pageLockData = {
  lockedPage: 0,
  //   requiredFields: [],
};

export { cleanData, pageLockData };
